<div class="control-bar ps-xxlarge-x" [class.expand-on-mobile]="expandOnMobile">
  <fcom-icon-button
    class="control absolute prev"
    [class.translate]="showChips"
    [disabled]="!(visibleMonthIndex > 0)"
    [icon]="{ category: 'svg-library', name: 'arrow-left' }"
    [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
    [size]="IconButtonSize.MEDIUM"
    [aria]="{ label: uiLabels?.showPreviousMonth }"
    (clickBtn)="selectMonth(visibleMonthIndex - 1)"
  >
  </fcom-icon-button>

  <div
    *ngIf="showChips"
    #monthChipParent
    class="ms-large-x ps-xsmall-y"
    [ngClass]="expandOnMobile ? 'chips' : 'scrollable-chips'"
    data-test-calendar-chips
  >
    <div #monthChips>
      <fcom-chip-button
        #chip
        *ngFor="let month of months; let i = index"
        [class.ms-xsmall-l]="i !== 0"
        [theme]="isChipHighlighted(i) ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
        [text]="getMonthNameForChip(month)"
        (chipClicked)="selectMonth(i)"
      >
      </fcom-chip-button>
    </div>
  </div>

  <fcom-icon-button
    class="control absolute next"
    [class.translate]="showChips"
    [disabled]="!(visibleMonthIndex < months.length - (noOfMonthsVisible === 1 ? 1 : 2))"
    [icon]="{ category: 'svg-library', name: 'arrow-right' }"
    [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
    [size]="IconButtonSize.MEDIUM"
    [aria]="{ label: uiLabels?.showNextMonth }"
    (clickBtn)="selectMonth(visibleMonthIndex + 1)"
  >
  </fcom-icon-button>
</div>

<div class="monthsArea flex-1 white-bg fill ps-xsmall-b" tabindex="-1" [class.expand-on-mobile]="expandOnMobile">
  <div
    class="months flex nowrap"
    [style.transform]="'translateX(-' + visibleMonthIndex * (noOfMonthsVisible === 1 ? 100 : 50) + '%)'"
    #calendarMonths
  >
    <fcom-calendar-month
      *ngFor="let month of months"
      class="month fill"
      [class.two-month-view]="noOfMonthsVisible === 2"
      [value]="month"
      [dateLabels]="dateLabels"
      [uiLabels]="uiLabels"
      [dayTemplate]="dayTemplate"
    ></fcom-calendar-month>
  </div>
</div>
